import {ApiClient} from '@hconnect/apiclient'
import {Iso8601} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {stringify} from 'qs'

import type {EquipmentExpertSystemUsageDto} from '../../types'

const QueryKeyPrefix = 'expert-system-usage'

type Params = {
  hierarchyId: string
  from?: Iso8601
  to?: Iso8601
}

export const useExpertSystemUsage = (
  {hierarchyId, from, to}: Params,
  options?: Omit<
    UseQueryOptions<EquipmentExpertSystemUsageDto[], AxiosError>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<EquipmentExpertSystemUsageDto[], AxiosError>({
    queryKey: [QueryKeyPrefix, hierarchyId, from, to],
    queryFn: async ({signal}) => {
      const path = `/expert-system/immediate-kpis/${hierarchyId}`
      const response = await ApiClient.axiosInstance.get<EquipmentExpertSystemUsageDto[]>(path, {
        params: {from, to},
        paramsSerializer: (params) => stringify(params, {arrayFormat: 'repeat'}),
        signal
      })
      return response.data ?? []
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    ...options
  })
}
